import React from "react";

import { Header, ScrollLayout } from "components";

import { strings } from "assets/constants";
import CreateCountry from "./CreateCountry";
import CreateZone from "./CreateZone";
import CreateCity from "./CreateCity";

const Countries = () => {
  return (
    <>
      <Header title={strings.countries} />
      <ScrollLayout
        style={{ alignSelf: "center", maxWidth: 600, width: "100%" }}
        contentContainerStyle={{ maxWidth: 600 }}
      >
        <CreateCountry />
        <CreateZone />
        <CreateCity />
      </ScrollLayout>
    </>
  );
};

export default Countries;
